<template>
	<GmapMap
		ref="planejamento_os_map"
		map-type-id="satellite"
		class="container__googlemaps__position"
		:center="{ lat: -17.390269, lng: -40.538804 }"
		:zoom="16"
		:options="{ disableDefaultUI: true }"
	>
		<PolygonShape
			:editable="false"
			:options="shapeOptionsFzda"
			:coordinates="getGeoJsonFzda.coordinates"
			:type="getGeoJsonFzda.type"
			:clickable="true"
		/>

		<PolygonShape
			v-for="(coordinateAndType, index) in getGeoJsonTlho.features"
			:key="`T-${index}`"
			:editable="false"
			:options="shapeOptionsTlho"
			:coordinates="coordinateAndType.coordinates"
			:type="coordinateAndType.type"
			:clickable="true"
		/>
		<PolygonShape
			v-for="coordinateAndType in getGeoJsonPtio.features"
			:key="coordinateAndType.properties['Codigo Plantio']"
			:editable="false"
			:position="coordinateAndType.position"
			:options="shapeOptionsPtio(coordinateAndType.properties)"
			:coordinates="coordinateAndType.coordinates"
			:type="coordinateAndType.type"
			:clickable="true"
			:click="placeMarker"
		/>

		<PolygonShape
			v-for="coordinateAndType in getGeoJsonBufferTalhao.features"
			:key="'Buffer-' + coordinateAndType.properties['Codigo Plantio']"
			:editable="false"
			:position="coordinateAndType.position"
			:options="shapeOptionsPtio(coordinateAndType.properties)"
			:coordinates="coordinateAndType.coordinates"
			:type="coordinateAndType.type"
			:clickable="true"
			:click="placeMarker"
		/>
		<PolygonShape
			v-for="(coordinateAndType, index) in getGeoJsonBufferParcela.features"
			:key="'BufferParcela-' + index"
			:editable="false"
			:position="coordinateAndType.position"
			:options="shapeOptionsPtio(coordinateAndType.properties)"
			:coordinates="coordinateAndType.coordinates"
			:type="coordinateAndType.type"
			:clickable="true"
			:click="placeMarker"
		/>
		<PlantioMarker
			v-for="(plantioMarker, index) in plantioMarkers"
			:key="`${index}-plantioMarker`"
			:plantio-marker="plantioMarker"
		/>
	</GmapMap>
</template>
<script>
import SHAPE_OPTIONS_FZDA from '../../../constants/ShapeOptions/ShapeFzda'
import SHAPE_OPTIONS_TLHO from '../../../constants/ShapeOptions/ShapeTlho'
import { SHAPE_OPTIONS_PLANTIO_POLIGONO } from '../../../constants/ShapeOptions/ShapePtio'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import PlantioMarker from '../../../components/PlantioMarker/PantioMarker.vue'

import PolygonShape from '../../../components/Map/PolygonShape'

// import ParcelaMarker from "../../../components/ParcelaMarker/ParcelaMarker";

import * as turf from '@turf/turf'

export default {
	components: {
		PolygonShape,
		PlantioMarker,
	},

	computed: {
		...mapGetters('moduleImportShape', [
			'getGeoJsonFzda',
			'plantioMarkers',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'getGeoJsonBufferTalhao',
			'getGeoJsonBufferParcela',
			'getGeoJsonPrcla',
		]),
		plantioMarkersParcelaInfo() {
			return this.plantioMarkers.map((plantioMarker) => {
				return Object.assign(plantioMarker, {
					intensidadeAmostral:
						plantioMarker.area /
						this.parcelas.filter((parcela) => parcela.plantioId === plantioMarker.infoPoligono.id)
							.length,
				})
			})
		},
	},

	watch: {
		'$store.state.moduleImportShape.bounds': {
			immediate: true,
			deep: true,
			handler(value) {
				if (Object.keys(value).length > 0 && this.$refs.planejamento_os_map) {
					this.$refs.planejamento_os_map.$mapPromise.then((map) => {
						map.fitBounds(value, 0)
					})
				}
			},
		},
	},

	methods: {
		desconsiderarParcela(event) {
			this.parcelas.splice(
				this.parcelas.indexOf(this.parcelas.find((parcela) => parcela.codigo === event)),
				1,
			)
		},
		openInfoWindow(ref) {
			this.$refs[ref][0].opened = true
		},
		updateCoordinates(event, codigo) {
			const point = turf.point([event.latLng.lng(), event.latLng.lat()])

			const parcela = this.parcelas.find((parcela) => parcela.codigo === codigo)
			if (this.isInAnyPlantio(point)) {
				this.parcelas.forEach((parcela) => {
					if (parcela.codigo === codigo) {
						parcela.coordenadaX = event.latLng.lng()
						parcela.coordenadaY = event.latLng.lat()
						parcela.idPlantio = this.findPlantioIdByPoint({
							coordenadaX: event.latLng.lng(),
							coordenadaY: event.latLng.lat(),
						}).properties.idPlantio
					}
				})

				if (parcela.id) {
					parcela.hasChanged = true
				}
			} else {
				if (parcela.id) this.$emit('deleteParcela', parcela.id)
				this.parcelas.splice(this.parcelas.indexOf(parcela), 1)
			}
		},
		placeMarker(event) {
			let coordenadaX = event.latLng.lng()
			let coordenadaY = event.latLng.lat()

			this.adicionaParcela({
				codigo: this.createCodigoParcela({
					coordenadaX,
					coordenadaY,
				}),
				coordenadaX,
				coordenadaY,
				plantioId: this.findPlantioIdByPoint({ coordenadaX, coordenadaY }).properties.idPlantio,
				icon: this.iconeParcela({
					draggable: true,
				}),
				infoOpened: false,
			})
		},
		...mapMutations('moduleImportShape', [
			'resetImportShapeState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonPtio',
			'setGeoJsonPrcla',
			'setFzdaHasFileInDB',
			'setPrclaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
		]),
		...mapActions('moduleImportShape', ['getShapesByFazendaId']),
	},
	props: {
		parcelas: { type: Array },
		createCodigoParcela: { type: Function },
		findPlantioIdByPoint: { type: Function },
		adicionaParcela: { type: Function },
		iconeParcela: { type: Function },
		isInAnyPlantio: { type: Function },
		showInfoPlantio: { type: Boolean, default: false },
	},
	data() {
		return {
			shapeOptionsFzda: SHAPE_OPTIONS_FZDA,
			shapeOptionsTlho: SHAPE_OPTIONS_TLHO,
			shapeOptionsPtio: SHAPE_OPTIONS_PLANTIO_POLIGONO,
			/**
			 * Exibe ou não o card para importar os shapes
			 */
			showImportShape: false,
			/**
			 * Exibe ou não o card para mapear colunas do shape com o sistema
			 */
			showMapData: false,
		}
	},
}
</script>
<style>
.container__googlemaps__position {
	width: 100%;
	height: 100%;
	position: relative;
}
.slider {
	-webkit-appearance: none;
	width: 100%;
	height: 15px;
	margin-bottom: 20px;

	border-radius: 5px;
	background: #d3d3d3;
	outline: none;
	opacity: 0.7;
	-webkit-transition: 0.2s;
	transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: absolute;
	top: 5rem;
	right: 0%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.slider::-moz-range-thumb {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #04aa6d;
	cursor: pointer;
}
</style>
